import { render, staticRenderFns } from "./cCarroMarca.vue?vue&type=template&id=27c6e1af&scoped=true"
import script from "./cCarroMarca.vue?vue&type=script&lang=js"
export * from "./cCarroMarca.vue?vue&type=script&lang=js"
import style0 from "./cCarroMarca.vue?vue&type=style&index=0&id=27c6e1af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c6e1af",
  null
  
)

export default component.exports